import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { HistoricalDataNaviItem } from '../../models/historical-data.interface';
import { SidenavService } from '../../services/sidenav/sidenav.service';
import { Subscription, take } from 'rxjs';
import { HistoricalDataComponent } from '../historical-data/historical-data.component';
import { MatDialog } from '@angular/material/dialog';
import { PatientAppointmentListComponent } from '../patient-appointment-list/patient-appointment-list.component';
import { IAppointment } from '../../models/appointment.interface';
import { SoapServiceService } from '../../services/soap-service/soap-service.service';
import { CVA_CONSTANTS } from '../../util/constants';
import { CVA_AUTH_MODULES } from '../../models/auth.modules.enum';

@Component({
    standalone: false,
    selector: 'cva-historical-data-menu-items',
    templateUrl: './side-nav-menu-items.component.html',
    styleUrl: './side-nav-menu-items.component.scss',
    
})
export class SideNavMenuItemsComponent implements OnInit, OnDestroy {
  @Input() isNavExpanded!: boolean;

  private patientId: string = '';
  private patientMRN: string = '';
  private readonly subScriptions: Subscription[] = [];
  historicalDataNavItems: HistoricalDataNaviItem[] = [];
  CVA_CONSTANTS = CVA_CONSTANTS;
  CVA_AUTH_MODULES = CVA_AUTH_MODULES;

  constructor(
    private readonly sidenavService: SidenavService,
    private readonly dialog: MatDialog,
    private readonly soapServiceService: SoapServiceService
  ) { }

  ngOnInit(): void {
    this.sidenavService.historicalDataNavItems$.pipe(take(1)).subscribe({
      next: (items) => (this.historicalDataNavItems = items),
    });

    this.sidenavService.patientId$.subscribe({
      next: (patientId) => (this.patientId = patientId),
    });

    this.sidenavService.patientMRN$.subscribe({
      next: (patientMRN) => (this.patientMRN = patientMRN),
    });

    if (history.state?.appointment) {
      const selectedAppointment: IAppointment = history.state?.appointment;
      this.patientId = selectedAppointment.patient.referenceId;
      this.patientMRN = selectedAppointment.patient.medicalRecordNumber;
    }

    const openHistoryPopUp$ = this.soapServiceService.openHistoryPopUp$.subscribe(sectionName => {
      if (sectionName) {
        this.historicalDataNavItems.forEach((navItems) => {
          if (navItems.title === sectionName) {
            this.closeDailog();
            this.openHistoricalDataModal(navItems);
          }
        })
      }
    });
    this.subScriptions.push(openHistoryPopUp$)

    const closeHistoryPopUp$ = this.soapServiceService.closeHistoryPopUp$.subscribe(() => {
      this.closeDailog();
    });
    this.subScriptions.push(closeHistoryPopUp$)

  }

  // this function will open common historical data modal
  openHistoricalDataModal(historicalDataNavItem: HistoricalDataNaviItem): void {
    const data: Record<string, string> = {
      patientId: this.patientId,
      category: historicalDataNavItem.category,
      title: historicalDataNavItem.title,
    };

    this.dialog.open(HistoricalDataComponent, {
      data,
      width: '80vw'
    });
  }

  closeDailog() {
    this.dialog.closeAll();
  }

  openPatientAppointment(): void {
    const data: Record<string, string> = {
      patientId: this.patientMRN,
    };

    this.dialog.open(PatientAppointmentListComponent, {
      height: '90%',
      width: '65vw',
      data,
      panelClass: 'custom-modalbox',
    });
  }
  ngOnDestroy() {
    this.subScriptions.forEach((sub) => {
      sub.unsubscribe();
    })
  }

  //This function is just to avoid SONAR warning
  doNothing() {
    console.log("Do nothing");
  }

}
